// Product page, sold-out variant: the grey "Sold out" button becomes "Sold out · Notify me when available"
// and opens the back-in-stock app's email popup (its floating side tab is hidden in base.css).
(() => {
  const ar = document.documentElement.lang === 'ar';
  const TXT = ar ? 'نفدت الكمية · أعلمني عند التوفر' : 'Sold out · Notify me when available';
  const apply = () => {
    const appReady = !!document.querySelector('.gw-float-widget');
    document.querySelectorAll('.product__info-container .product-form__submit').forEach((b) => {
      const wrap = b.closest('.product-form__buttons');
      const span = b.querySelector('span') || b;
      const on = b.disabled && appReady;
      if (wrap) wrap.classList.toggle('bjo-notify', on);
      if (on && span.textContent.trim() !== TXT) span.textContent = TXT;
    });
  };
  // disabled buttons swallow clicks, so the button ignores pointer events (base.css) and the wrapper takes the tap
  document.addEventListener('click', (e) => {
    const wrap = e.target.closest && e.target.closest('.product-form__buttons.bjo-notify');
    const btn = wrap && wrap.querySelector('.product-form__submit');
    const tab = document.querySelector('.gw-float-widget');
    if (!btn || !btn.disabled || !tab) return;
    e.preventDefault();
    tab.click();
  });
  // The app's email popup is a same-origin srcdoc iframe: restyle it to the site look and translate it.
  const T = ar ? {
    'X': '×',
    'NOTIFY ME WHEN AVAILABLE': 'أعلمني عند التوفر',
    'We will notify you when the product is back in stock': 'سنرسل لك بريدًا إلكترونيًا عند توفر المنتج من جديد.',
    'Email Address': 'البريد الإلكتروني',
    'Please Provide Valid Email': 'يرجى إدخال بريد إلكتروني صحيح',
    'Notify Me': 'أعلمني',
    'Your notification has been registered.': 'تم! سنرسل لك بريدًا عند توفّره.',
    'Close': 'إغلاق',
    'Signup for newsletter?': 'الاشتراك في النشرة البريدية؟',
    'We respect your privacy and do not share your email with anyone.': 'نحترم خصوصيتك ولن نشارك بريدك الإلكتروني مع أحد.'
  } : {
    'X': '×',
    'NOTIFY ME WHEN AVAILABLE': 'Notify me when available',
    'Email Address': 'Your email',
    'Notify Me': 'Notify me',
    'Your notification has been registered.': "Done! We'll email you when it's back."
  };
  const fontFaces = () => {
    let css = '';
    for (const sh of document.styleSheets) {
      try { for (const r of sh.cssRules) if (r.type === CSSRule.FONT_FACE_RULE) css += r.cssText + '\n'; } catch (e) { /* cross-origin sheet */ }
    }
    return css;
  };
  const CSS = (font) => `
    * { color: #3c3c3c; font-family: ${font} !important; }
    /* look of the SAMEDAY popup: dark dim (blur is on the iframe itself, base.css), grey card, round × */
    .fade-in { background: rgba(0,0,0,.45) !important; }
    .modal-container { background: #ececec !important; border: 0 !important; border-radius: 20px !important; padding: 30px 22px 18px !important;
      box-shadow: 0 20px 60px rgba(0,0,0,.35) !important; width: min(400px, calc(100vw - 24px)) !important; }
    @media (max-width: 749px) { .modal-container { border-radius: 14px !important; } }
    .modal-title { font-size: 20px !important; font-weight: 800 !important; text-transform: none !important; letter-spacing: 0 !important; padding-inline-end: 44px; }
    .notification-message { font-size: 15px !important; margin: 6px 0 16px !important; color: rgba(60,60,60,.75) !important; }
    .email-input, .v-select .vs__dropdown-toggle { background: #fff !important; border: 0 !important; border-radius: 12px !important;
      box-shadow: none !important; font-size: 16px !important; height: 48px; }
    .v-select { margin-bottom: 12px; }
    .email-input::placeholder { color: rgba(60,60,60,.5) !important; font-weight: 500; }
    .notify-button { background: #3c3c3c !important; border: 0 !important; border-radius: 10px !important; font-size: 16px !important;
      font-weight: 700 !important; padding: 14px !important; margin-top: 12px !important; }
    .notify-button, .notify-button * { color: #fff !important; }
    .close-icon { position: absolute !important; top: 12px !important; right: 12px !important; width: 42px !important; height: 42px !important;
      border-radius: 50% !important; background: rgba(255,255,255,.6) !important; color: #222 !important; font-size: 26px !important;
      line-height: 42px !important; text-align: center !important; padding: 0 !important; margin: 0 !important; opacity: 1 !important; cursor: pointer; }
    .privacy-text, .privacy-text * { font-size: 12px !important; color: rgba(60,60,60,.6) !important; }
    ${ar ? '.modal-container { direction: rtl; text-align: right; } .modal-title { padding-inline-end: 0; padding-inline-start: 44px; } .close-icon { right: auto !important; left: 12px !important; }' : ''}`;
  const translate = (doc) => {
    const w = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    for (let n = w.nextNode(); n; n = w.nextNode()) {
      const k = n.nodeValue.trim();
      if (T[k]) n.nodeValue = n.nodeValue.replace(k, T[k]);
    }
    doc.querySelectorAll('input[placeholder]').forEach((i) => { if (T[i.placeholder]) i.placeholder = T[i.placeholder]; });
  };
  const dressModal = () => {
    const f = document.getElementById('gw-stock-fulfilled-iframe');
    const doc = f && f.contentDocument;
    if (!doc || !doc.body) return;
    if (!doc.getElementById('bjo-gw-style')) {
      const st = doc.createElement('style');
      st.id = 'bjo-gw-style';
      st.textContent = fontFaces() + CSS(getComputedStyle(document.body).fontFamily);
      doc.head.appendChild(st);
      new MutationObserver(() => translate(doc)).observe(doc.body, { subtree: true, childList: true, characterData: true });
    }
    translate(doc);
  };
  // Globo related / recently-viewed rows: friendlier titles (Arabic titles are set in base.css ::before).
  // Fully sold-out products are already hidden by the app (settings.sold_out=false); sold-out sizes stay, labelled.
  const TITLES = [
    [/^(Related Products|منتجات ذات صلة)$/, ar ? 'قد يعجبك أيضًا' : 'You may also like'],
    [/^(Recently Viewed Products|تصفحتها مؤخراً|تصفحتها مؤخرًا)$/, ar ? 'تصفحتها مؤخرًا' : 'Recently viewed']
  ];
  const fixGlobo = () => {
    if (ar) document.querySelectorAll('.ga-product_variant_select option').forEach((o) => {
      if (/ - Sold out\s*$/.test(o.text)) o.text = o.text.replace(/ - Sold out\s*$/, ' - نفدت الكمية');
    });
    document.querySelectorAll('.ga-products-box .ga-title, .ga-products-box .ga-title span').forEach((t) => {
      if (t.children.length) return;
      const k = t.textContent.trim();
      TITLES.forEach(([re, v]) => { if (re.test(k) && k !== v) t.textContent = v; }); // k !== v: never rewrite the same text (that loops the observer)
    });
  };
  const tick = () => { apply(); dressModal(); fixGlobo(); };
  new MutationObserver(tick).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  document.addEventListener('load', (e) => { if (e.target && e.target.id === 'gw-stock-fulfilled-iframe') dressModal(); }, true);
  tick();
})();
